<script lang="ts">
	import { userClientData } from '../../stores';
</script>

<img
	class="logo"
	style={`max-width: ${$userClientData.webData.logoWidth};
        ${
					$userClientData.webData.logoMarginTop
						? 'margin-top:' + $userClientData.webData.logoMarginTop
						: ''
				}`}
	src={$userClientData.webData.logoSrc}
	alt="AdPicker logo"
/>

<style>
	.logo {
		margin: 32px auto 16px;
		display: block;
		max-width: 100%;
	}
</style>
